module.exports = __webpack_public_path__ + "static/lab-header-menu-proje-81345783bd7f6ea69f653777d06b2967.webp";